import { useCallback } from 'react';

import { type AccountAddress, Aptos, AptosConfig, Network } from '@aptos-labs/ts-sdk';
import { useWallet, type WalletName } from '@aptos-labs/wallet-adapter-react';

export function usePetraWallet() {
    const { connect, connected, account, signTransaction, signMessage, wallet } = useWallet();

    const handlePetraConnect = useCallback(async () => {
        if (!connected || !account) {
            connect(wallet?.name || ('Petra' as WalletName));
        }
        return account;
    }, [account, connect, connected, wallet?.name]);

    const handleTransaction = useCallback(
        async (transactionPayload) => {
            const aptosConfig = new AptosConfig({ network: Network.MAINNET });
            const aptos = new Aptos(aptosConfig);
            if (!connected) {
                await handlePetraConnect();
            }

            if (transactionPayload && account?.address) {
                const transaction = await aptos.transaction.build.simple({
                    sender: account.address as unknown as AccountAddress,
                    data: {
                        function: transactionPayload.function,
                        typeArguments: transactionPayload.type_arguments,
                        functionArguments: transactionPayload.arguments,
                    },
                });
                //TODO: neaten up and ensure different order types don't need a separate structure

                if (transaction) {
                    const signed = await signTransaction(
                        {
                            rawTransaction: transaction.rawTransaction,
                            feePayerAddress: account.address as unknown as AccountAddress,
                        },
                        true,
                    );

                    if (signed) {
                        if (signed) {
                            return signed;
                        }
                    }
                }
            }
        },
        [account?.address, connected, handlePetraConnect, signTransaction],
    );

    return { handlePetraConnect, handleTransaction, signMessage };
}
